import Duck from 'extensible-duck';
import { createSelector } from 'reselect';

export default new Duck({
  namespace: 'GEORDERSEARCH',
  store: 'orderSearch',
  initialState: {
    orderIDMapping: {},
    selectedOrder: undefined,
  },
  types: [
    'FETCH_ORDERID_MAPPING',
    'SET_ORDERID_MAPPING',
    'SET_SELECTED_ORDER_GUID',
  ],
  creators: duck => ({
    fetchOrderIDMapping: () => ({ type: duck.types.FETCH_ORDERID_MAPPING }),
    setOrderIDMapping: mapping => ({
      type: duck.types.SET_ORDERID_MAPPING,
      mapping,
    }),
    setSelectedOrder: order => ({
      type: duck.types.SET_SELECTED_ORDER_GUID,
      order,
    }),
  }),
  selectors: duck => ({
    base: state => state[duck.store],

    orderIDMapping: new Duck.Selector(selectors =>
      createSelector(selectors.base, orderSearch => orderSearch.orderIDMapping),
    ),

    orderIDs: new Duck.Selector(selectors =>
      createSelector(
        selectors.orderIDMapping,
        mapping => (mapping ? Object.keys(mapping) : []),
      ),
    ),

    selectedOrder: new Duck.Selector(selectors =>
      createSelector(selectors.base, orderSearch => orderSearch.selectedOrder),
    ),

    selectedOrderID: new Duck.Selector(selectors =>
      createSelector(
        selectors.selectedOrder,
        selectedOrder => (selectedOrder ? selectedOrder.orderID : null),
      ),
    ),

    selectedOrderGuid: new Duck.Selector(selectors =>
      createSelector(
        selectors.selectedOrder,
        selectedOrder => (selectedOrder ? selectedOrder.orderGUID : null),
      ),
    ),
  }),
  reducer: (state, action, duck) => {
    switch (action.type) {
      case duck.types.SET_ORDERID_MAPPING: {
        const { mapping } = action;
        return {
          ...state,
          orderIDMapping: mapping,
        };
      }
      case duck.types.SET_SELECTED_ORDER_GUID: {
        const { order } = action;
        return {
          ...state,
          selectedOrder: order,
        };
      }
      default: {
        return state;
      }
    }
  },
});
